"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _internals_1 = require("../_internals");
const symbols_1 = require("../_internals/symbols");
const Union_1 = require("../Union");
const union_1 = __importDefault(require("../Union/union"));
const IODefs = {
    trivials: ["IO"],
    identities: [],
    pure: "IO",
    pureM: "IO",
    lazy: true,
    overrides: {
        fmap: {
            IO(fn) {
                return IO.pure((0, _internals_1.compose2)(fn, (0, symbols_1.getInnerValue)(this)));
            },
        },
        chain: {
            IO(fn) {
                return IO.pure(() => fn(this.unsafeRun()).unsafeRun());
            },
        },
        join: {
            IO() {
                return IO.pure(() => this.unsafeRun().unsafeRun());
            }
        },
        apply: {
            IO(ioFn) {
                return IO.pure((...args) => ioFn.get()(this.get()(...args)));
            },
        },
        show: {
            IO() {
                return `[IO => () => _]`;
            },
        },
        run: {
            IO() {
                return this.get()();
            },
        },
        toPromise: {
            IO() {
                return Promise.resolve(this.run());
            }
        },
        toThenable: {
            IO() {
                return {
                    then: (res, rej) => {
                        try {
                            res(this.run());
                        }
                        catch (e) {
                            rej(e);
                        }
                    }
                };
            }
        }
    },
};
function defaultIO(x) {
    return this.IO(x);
}
function passThrough(fn) {
    return (...args) => this.IO(() => fn(...args));
}
const IO = (0, union_1.default)("IO", {
    IO: (fn) => (...args) => (0, _internals_1.extractWith)(args)(fn),
}, [
    (0, Union_1.Functor)(IODefs),
    (0, Union_1.Applicative)(IODefs),
    (0, Union_1.Monad)(IODefs),
    (0, Union_1.Thenable)(IODefs),
    (0, Union_1.Show)(IODefs),
    (0, Union_1.Tap)(IODefs),
    (0, Union_1.Runnable)(IODefs)
]).constructors({
    of: defaultIO,
    from: defaultIO,
    forward: passThrough,
    through: passThrough,
    unary(fn) { return (x) => this.IO(() => fn(x)); }
});
exports.default = IO;
